import signalApiService from '@/request/signal/signal.api.service';
import { ISignalDailyToken } from '@/request/signal/signal.response.interface';
import { useBoomWallet } from '@boomeme/wallet-sdk';
import { useEffect, useState } from 'react';

export const useDailyToken = () => {
  const { chain } = useBoomWallet();
  const [loading, setLoading] = useState<boolean>(true);
  const [dailyList, setDailyList] = useState<ISignalDailyToken[]>([]);
  const [isFetching, setIsFetching] = useState<boolean>(false);
  const fetchDailyToken = async () => {
    if (isFetching) return;
    setIsFetching(true);
    try {
      const res = await signalApiService.getSignalDailyListApi();
      if (res.code == 0) {
        setDailyList(res.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsFetching(false);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDailyToken();
  }, [chain]);

  return {
    loading,
    dailyList,
  };
};
